'use client';

import React from 'react';
import { getPageSection, PageSections } from '@/pageBuilder';

const Goal = ({ goalData }: { goalData: any }) => (
  goalData.content && goalData.content.map((section: any) => (
    <React.Fragment key={section.__component}>
      {getPageSection({
        name: section.__component as PageSections,
        props: {
          data: section,
          ingredients: goalData.ingredients,
        },
      })}
    </React.Fragment>
  ))
);

export default Goal;
